import React, { useEffect, useState } from 'react';
import { Header, StepsFlow } from './components';
import AppRoutes from './routes';
import {
  ModalBackground,
  ModalContainer,
  ModalBody,
} from './AppStyledComponents';
import {
  FontStyles,
  GreenCardHelpOverlay,
  SeparationLine,
} from './styles/GlobalStyledComponents';
import { StyleSheetManager, ThemeProvider } from 'styled-components';
import { theme } from './styles/Theme';
import { BrowserRouter as Router } from 'react-router-dom';
import { clarity } from 'clarity-js';
import { ROUTES_PATH } from './constants';
import './styles/fontStyles.scss';
import './styles/custom.scss';
import { MainContextProvider } from './contexts';
import { initializeAnalytics } from './services/Firebase';
import isPropValid from '@emotion/is-prop-valid';

export const WindowContext = React.createContext<any>({} as any);

const App = (): JSX.Element => {
  const [closeButton, setCloseButton] = useState<boolean>(true);
  const [removeArrow, setRemoveArrow] = useState(false);
  const [bankreaderArrow, setBankreaderArrow] = useState(false);
  const [resizeScreen, setResizeScreen] = useState<boolean>(false);
  const [greenCardOverlay, setGreenCardOverlay] = useState<boolean>(false);
  const paddingModal =  window.location.pathname === ROUTES_PATH.COUNTER_OFFER ? '2rem' : '2.5rem';
  const flexModal =  window.location.pathname === ROUTES_PATH.COUNTER_OFFER ? 'flex' : 'block';

const shouldForwardProp = (propName: any, target: any) => {
  if (typeof target === 'string') {
// If the target is a DOM element, only forward valid HTML props
    return isPropValid(propName);
  }
// If the target is a component, forward everything
  return true;
}

  const handleCloseButton = (data: boolean) => {
    setCloseButton(data);
  };

  useEffect(() => {
    clarity.start({
      projectId: import.meta.env.VITE_CLARITY_KEY,
      upload: 'https://m.clarity.ms/collect',
      track: true,
      content: true,
    });
    initializeAnalytics();
  }, []);

  return (
    <Router>
      <WindowContext.Provider value={window}>
        <StyleSheetManager shouldForwardProp={shouldForwardProp}>
        <ThemeProvider theme={theme}>
          <FontStyles />
          <ModalBackground id="modal-bg">
            <ModalContainer id="modal-container" $display={flexModal}>
              {greenCardOverlay && <GreenCardHelpOverlay />}
              <MainContextProvider>
                <Header
                  closeButton={closeButton}
                  removeArrow={removeArrow}
                  bankreaderArrow={bankreaderArrow}
                />
                <SeparationLine />
                <StepsFlow />
                <ModalBody $resize={resizeScreen.toString()} $paddingModal={paddingModal?.toString()}>
                  <AppRoutes
                    closeButton={handleCloseButton}
                    iframeResize={(e) => setResizeScreen(true)}
                    removeArrow={(e) => setRemoveArrow(e)}
                    bankreaderArrow={(e) => setBankreaderArrow(e)}
                    greenCardOverlayEvent={setGreenCardOverlay}
                  />
                </ModalBody>
              </MainContextProvider>
            </ModalContainer>
          </ModalBackground>
        </ThemeProvider>
        </StyleSheetManager>
      </WindowContext.Provider>
    </Router>
  );
};

export default App;
